import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";
import trend from "../assets/images/trend.png";
import logo4 from "../assets/images/logo4.png";
import logo1 from "../assets/images/logo1.png";
import arrow from "../assets/images/arrow.png";
import info from "../assets/images/info.png";
import home from "../assets/images/home.png";
import "./sidepanel.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SidePanel = ({ onSignout }) => {
  const handleSignout = () => {
    toast.info("You have successfully signed out!");
    setTimeout(() => {
      onSignout();
    }, 2000); // Delay sign-out to display the toast notification
  };

  return (
    <div className="side-panel">
      <div className="user">
        <div className="img">
          <img src={logo} alt="logo" />
        </div>
      </div>

      <div className="link-container">
        <ul className="link-content">
          <li>
            <Link to="/" className="menu-item">
              <img src={trend} alt="Dashboard" />
              <span className="tool">Dashboard</span>
            </Link>
          </li>

          <li>
            <Link to="/customer" className="menu-item">
              <img src={logo4} alt="Customer" />
              <span className="tool">Customer</span>
            </Link>
          </li>

          <li>
            <Link to="/order" className="menu-item">
              <img src={logo1} alt="Order" />
              <span className="tool">Orders</span>
            </Link>
          </li>

          <li>
            <Link to="/product" className="menu-item">
              <img src={home} alt="Product" />
              <span className="tool">Products</span>
            </Link>
          </li>

          <li>
            <Link to="/about" className="menu-item">
              <img src={info} alt="About" />
              <span className="tool">About</span>
            </Link>
          </li>

          <li onClick={handleSignout} className="menu-item" style={{ cursor: "pointer" }}>
            <img src={arrow} alt="Signout" />
            <span className="tool">Sign Out</span>
          </li>
        </ul>
      </div>
      <ToastContainer style={{ zIndex: 1000, top: "85px" }} />
    </div>
  );
};

export default SidePanel;






